module.exports = __webpack_public_path__ + "img/tank-division.a85f30ac.jpg";